/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop75Filled = createReactComponent("filled", "crop-7-5-filled", "IconCrop75Filled", [["path", { "d": "M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconCrop75Filled as default };
//# sourceMappingURL=IconCrop75Filled.mjs.map
